import React from "react";
import styled from "styled-components";
import { Button, Result as AntResult } from "antd";
import { useTranslation } from "react-i18next";

const Result = styled(AntResult)`
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 !important;

  .ant-result-title, .ant-result-subtitle {
    font-size: 14px !important;
    color: ${props => props.theme.textColor} !important;
    font-weight: 400 !important;
  }
  .ant-btn-primary {
    background: ${props => props.theme.white} !important;
  }
`;

const NoInternet = () => {
  const { t } = useTranslation();

  return (
    <Result
      icon={false}
      title={t("error.noInternetTitle")}
      subTitle={t("error.noInternetSubtitle")}
      extra={
        <Button type="primary" onClick={() => window.location.reload()}>
          {t("error.retry")}
        </Button>
      }
    />
  );
};

export default NoInternet;
